function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectLuminaire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 6.3499999 6.3500002",
    stroke: "currentColor",
    fill: "currentColor",
    id: "svg134",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.264583,
      strokeOpacity: 1
    },
    id: "rect1216",
    width: 0.33408689,
    height: 1.8541822,
    x: 0.69025058,
    y: 1.637026
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.265,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "rect1226",
    width: 0.76839989,
    height: 0.71828687,
    x: 0.47309402,
    y: 1.3196434
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      strokeWidth: "0.264583px",
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeOpacity: 1
    },
    d: "m 1.7092154,1.1448045 2.8898519,0.0078 -0.016705,-0.054572 -1.2027127,-0.062363 H 2.9954502 l -1.2862348,0.046772 z",
    id: "path1232"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      strokeWidth: 0.265,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 0.47309407,1.3196433 0.57332007,0.58465208 2.0600068,0.53453904 3.3629458,0.8853303 1.7092154,1.1448045 1.2414939,1.3196433 Z",
    id: "path1234"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.10583333,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1,
      strokeMiterlimit: 4,
      strokeDasharray: "none"
    },
    d: "M 6.2140165,0.16704345 C 0.13363476,6.2307207 0.11693042,6.2474252 0.11693042,6.2474252",
    id: "path1236"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fillOpacity: 1,
      strokeWidth: 0.105833,
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path1240",
    cx: 4.8776693,
    cy: 3.7751832,
    rx: 1.1358954,
    ry: 0.21715648
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillOpacity: 1,
      strokeWidth: 0.0529167,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.7417739,3.7584773 4.810852,2.7395121 4.9945998,2.722809 6.0135647,3.7751826 Z",
    id: "path1242"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.15875,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 3.7417739,3.7584791 4.7106257,5.445618 4.8609648,5.4289122 6.0135647,3.7751831 3.7417739,3.7584773",
    id: "path1246"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      strokeWidth: 0.264583
    },
    id: "rect1250",
    width: 0.37594032,
    height: 0.48442611,
    x: 4.5852499,
    y: 5.4289122
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectLuminaire);
export default __webpack_public_path__ + "static/media/SelectLuminaire.4e07c255ae8ddc587f480d94affab432.svg";
export { ForwardRef as ReactComponent };